import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AboutComponent } from './components/about/about.component';
import { AppContainerComponent } from './components/app-container/app-container.component';
import { SaveTimerComponent } from './save-timer/save-timer.component';
import { SideMenuSectionComponent } from './side-menu/side-menu-section/side-menu-section.component';
import { SideMenuComponent } from './side-menu/side-menu.component';

@NgModule({
  declarations: [
    AboutComponent,
    AppContainerComponent,
    SideMenuSectionComponent,
    SideMenuComponent,
    SaveTimerComponent
  ],
  imports: [ConfirmDialogModule, CommonModule, TranslateModule, RouterModule, MatTooltipModule]
})
export class CoreModule {}
